import { AlertSrv, AppSettings, session } from '../components/fx';
import axios from 'axios';
import { ProgressManager } from '../components/fx/progress';
import { saveAs } from 'file-saver';

// const apiBasePath = process.env.NEXT_PUBLIC_API_BASE_URL;
const apiBasePath = AppSettings.APP_API_URL;

export const axiosInstance = axios.create({
  baseURL: apiBasePath,
  timeout: 30000,
});

const computeConfig = ({ options, token }: any) => {
  let url = options.url;
  let method = options.method;
  let data = options.data;

  if (!token) {
    token = session.getItem("accessToken");
  }

  let config: any = {
    baseURL: apiBasePath,
    url,
    method,
    data
  };
  let tokenHeaders = {};
  let optionHeaders = options.headers || {};
  if (token) tokenHeaders = { 'Authorization': `Bearer ${token}` }
  config.headers = { ...tokenHeaders, ...optionHeaders };
  return config;
}

const doAction = async (options: any, token: any = "") => {
  const config = computeConfig({ options, token });
  const result = await axiosInstance.request(config);
  return result?.data;
}

const doDownload = (options: any, token: any = "") => {
  let config = computeConfig({ options, token });
  config.responseType = 'blob';
  axiosInstance.request(config)
    .then((res) => {
      let blob = res.data;
      saveAs(blob, options.fileName);
    });
}

//Interceptors starts
axiosInstance.interceptors.request.use((value: any) => {
  ProgressManager.open();
  return value;
}, undefined);

axiosInstance.interceptors.response.use((response) => {
  ProgressManager.close();
  //TODO: handle 401 
  // if (response.data && response.data.message === "Unauth") {
  //     window.location.href = `${baseWebURL}/unauthorize`;
  // }
  return response;
}, (error) => {
  ProgressManager.close();
  if (error.response && error.response.data) {
    if (error.response.data.message) {
      AlertSrv.showErrorMsg(error.response.data.message);
    }
    return Promise.reject(error.response.data);
  }
  return Promise.reject(error);
});
//Interceptors ends

export const apiClient = {
  doAction: doAction,
  doDownload: doDownload
}

